import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { PortalGlobals } from '../../../app/portalglobals'

@Injectable()
export class UserDataService {
    private messageSource = new BehaviorSubject<boolean>(true)
    private selectedYearSource = new BehaviorSubject<number>(0)
    private availablePlanYearsMessageSource = new BehaviorSubject<number[]>([] as number[])
    private insuranceCompanyOrgIdSource = new BehaviorSubject<number>(0)

    public currentMessage = this.messageSource.asObservable()
    public currentYear = this.selectedYearSource.asObservable()
    public insuranceCompanyOrgId = this.insuranceCompanyOrgIdSource.asObservable()

    constructor(private portalGlobals: PortalGlobals) {
        var planYearStr = sessionStorage.getItem('PLANYEAR')
        if (planYearStr !== undefined) {
            portalGlobals.selectedPlanYear = Number(planYearStr)
        }
    }

    changeMessage(showheader: boolean) {
        this.messageSource.next(showheader)
    }
    changeSelectedYear(selectedYear: number) {
        this.portalGlobals.selectedPlanYear = selectedYear
        sessionStorage.setItem('PLANYEAR', String(selectedYear))
        this.selectedYearSource.next(selectedYear)
    }

    changeAvailableYears(availableYears: number[]) {
        this.availablePlanYearsMessageSource.next(availableYears)
    }

    changeInsuranceCompanyOrgId(insuranceCompanyOrgId: number) {
        this.portalGlobals.insuranceCoOrgID = insuranceCompanyOrgId
        this.insuranceCompanyOrgIdSource.next(insuranceCompanyOrgId)
    }
}
